// assets
import { IconFile } from '@tabler/icons';
import genChild from './RepChild';

// constant
const icons = { IconFile };

const reportGrp = {
    id: `generateReportGrp-${Math.random()}`,
    title: 'Reports',
    type: 'group',
    // url: `/dashboard/default`,
    icon: icons.IconFile,
    breadcrumbs: false,
    children: genChild,
    role: process.env.REACT_APP_RL_GENGRP
};

export default reportGrp;